<template>
  <div>
    <form class="form-horizontal">
      <h1 class="section-divider">{{ $t('profileApproval.currentInfo') }}</h1>
      <div class="row" style="font-size: 12px;">
        <div class="col-md-3">
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">{{
              $t('profileApproval.lastNameKh')
            }}</span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">
                {{ info.last_name_kh ? info.last_name_kh : '-' }}
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">{{
              $t('profileApproval.firstNameKh')
            }}</span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">
                {{ info.first_name_kh ? info.first_name_kh : '-' }}
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">{{
              $t('profileApproval.lastNameEn')
            }}</span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">
                {{ info.last_name_en ? info.last_name_en : '-' }}
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">{{
              $t('profileApproval.firstNameEn')
            }}</span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">
                {{ info.first_name_en ? info.first_name_en : '-' }}
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">{{
              $t('profileApproval.sex')
            }}</span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">
                {{ info.gender ? info.gender : '-' }}
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">{{
              $t('profileApproval.dateOfBirth')
            }}</span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">
                {{ info.date_of_birth ? info.date_of_birth : '-' }}
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">{{
              $t('profileApproval.placeOfBirth')
            }}</span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">
                {{ info.place_of_birth ? info.place_of_birth : '-' }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">{{
              $t('profileApproval.phoneNumber')
            }}</span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">
                {{ info.phone ? info.phone : '-' }}
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">{{
              $t('profileApproval.email')
            }}</span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">
                {{ info.email ? info.email : '-' }}
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">{{
              $t('profileApproval.facebook')
            }}</span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">
                {{ info.facebook_account ? info.facebook_account : '-' }}
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">{{
              $t('profileApproval.emergencyContactPerson')
            }}</span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">
                {{
                  info.emergency_contact_person
                    ? info.emergency_contact_person
                    : '-'
                }}
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">{{
              $t('profileApproval.emergencyContactRelation')
            }}</span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">
                {{
                  info.emergency_contact_relation
                    ? info.emergency_contact_relation
                    : '-'
                }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">{{
              $t('profileApproval.province')
            }}</span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">
                {{ info.province ? info.province.province_name : '-' }}
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">{{
              $t('profileApproval.district')
            }}</span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">
                {{ info.district ? info.district.district_name : '-' }}
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">{{
              $t('profileApproval.commune')
            }}</span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">
                {{ info.commune ? info.commune.commune_name : '-' }}
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">{{
              $t('profileApproval.village')
            }}</span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">
                {{ info.village ? info.village.village_name : '-' }}
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">{{
              $t('profileApproval.streetNo')
            }}</span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">
                {{ info.street_no ? info.street_no : '-' }}
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">{{
              $t('profileApproval.houseNo')
            }}</span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">
                {{ info.house_no ? info.house_no : '-' }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="row form-group">
            <div class="col-md-12 text-center">
              <div id="img-frame" class="text-center">
                <img
                  v-lazy="{
                    src: photo(info),
                    error: onError(info),
                    loading: require('@/assets/Rolling-1s-200px_2.svg')
                  }"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'motherCurrentInfo',
  props: ['info', 'edit'],
  data() {
    return {
      errors: new Errors(),
      boyPhoto: require('../../../../../assets/student-default-boy.png'),
      girlPhoto: require('../../../../../assets/student-default-girl.png'),
      file: require('../../../../../assets/user_default.png')
    }
  },
  methods: {
    photo(record) {
      if (record.photo) {
        return record.photo
      }
      if (record.gender == 'Male' || record.gender == 'M') {
        return this.boyPhoto
      }
      if (record.gender == 'Female' || record.gender == 'F') {
        return this.girlPhoto
      }
    },
    onError(record) {
      event
        ? (event.target.src =
            record.gender == 'Male' ? this.boyPhoto : this.girlPhoto)
        : ''
    }
  }
}
</script>
<style lang="css" scoped>
#cover-image img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.section-divider {
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}
.text-uppercase {
  text-transform: uppercase !important;
}
#img-frame {
  display: block;
  position: relative;
  margin-top: 5px;
}
#img-frame img {
  object-fit: contain;
  width: 45%;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 3px;
  margin: 0 auto;
}
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
